import { render } from "./ContentShare.vue?vue&type=template&id=8398c004&scoped=true"
import script from "./ContentShare.vue?vue&type=script&lang=js"
export * from "./ContentShare.vue?vue&type=script&lang=js"

import "./ContentShare.vue?vue&type=style&index=0&id=8398c004&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8398c004"]])

export default __exports__